import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { AMITASOFT_BRAND } from "../../theme/amitasoftBrand";
import { AMITASOFT_TYPO } from "../../theme/amitasoftTypography";

function BannerMain() {
  return (
    <Box
      sx={{
        background: AMITASOFT_BRAND.gradientHero,
        py: { xs: 7, sm: 9, md: 11 },
        px: 2,
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" maxWidth={760} mx="auto">
          <Typography
            component="h1"
            sx={{
              fontFamily: AMITASOFT_TYPO.fontFamily,
              fontWeight: 700,
              ...AMITASOFT_TYPO.hero,
              color: AMITASOFT_BRAND.white,
              mb: 2,
            }}
          >
            AmitaSoft Blogs
          </Typography>
          <Typography
            sx={{
              fontFamily: AMITASOFT_TYPO.fontFamily,
              fontWeight: 400,
              fontSize: "clamp(1rem, 1.54vw, 1.31rem)",
              lineHeight: 1.24,
              color: "rgba(255,255,255,0.92)",
            }}
          >
            Insights on Digital Transformation and Enterprise Trust
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default BannerMain;
